import React from "react";

import ReusableTest from "../ReusableTest";

function Test() {
  return <ReusableTest path="listening_test/smw" category="smw"></ReusableTest>;
}

export default Test;
